import { faClipboardList } from '@fortawesome/pro-solid-svg-icons';

import { NavRoute } from '../../shared/navigation/nav.route.interface';
import { ReportTypeEnum } from '../enums/generated/ReportTypeEnum';

export const getMainNavReports: () => NavRoute = () => {
	const navItems: NavRoute[] = [];

	navItems.push({
		name: 'Inventory Count'
		, exact: true
		, path: `reports/inventory-count`   
        , activeNavLink: 'reports/inventory-count'
        , secondaryNav: ['Reports', 'Inventory Count']     
	});
	
	navItems.push({
		name: 'Summary'
		, security: security => security.adminFeatures
		, children: [
			{
				name: 'Florida Regions'
				, exact: true
				, path: `reports/summary/regions`
                , activeNavLink: 'reports/summary/regions'
                , secondaryNav: ['Reports', 'Summary', 'Florida Regions']
			}
            , {
				name: 'Counties'
				, exact: true
				, path: `reports/summary/counties`
                , activeNavLink: 'reports/summary/counties'
		        , secondaryNav: ['Reports', 'Summary', 'Counties']
			}
            , {
				name: 'Organizations'
				, exact: true
				, path: `reports/summary/organizations`
                , activeNavLink: 'reports/summary/organizations'
		        , secondaryNav: ['Reports', 'Summary', 'Organizations']
			}
            , {
				name: 'Sites'
				, exact: true
				, path: `reports/summary/sites`
                , activeNavLink: 'reports/summary/sites'
		        , secondaryNav: ['Reports', 'Summary', 'Sites']
			}
		]		
	});

	navItems.push({
		name: 'Burn Rate'
        , exact: true
        , path: `reports/burn-rate`
        , activeNavLink: 'reports/burn-rate'
        , secondaryNav: ['Reports', 'Burn Rate']
		, security: security => security.adminFeatures
		, children: getBurnRateChildren()
	});
	
	navItems.push({
		name: 'By Product'
		, security: security => security.adminFeatures
		, children: [
			{
				name: 'Florida Regions'
				, exact: true
				, path: `reports/by-product/Region`
				, queryParams: { reportType: ReportTypeEnum.Region }
                , activeNavLink: 'reports/by-product/Region'
                , secondaryNav: ['Reports', 'By Product', 'Florida Regions']
			}
            , {
				name: 'Counties'
				, exact: true
				, path: `reports/by-product/County`
				, queryParams: { reportType: ReportTypeEnum.County }
                , activeNavLink: 'reports/by-product/County'
                , secondaryNav: ['Reports', 'By Product', 'Counties']
			}
            , {
				name: 'Organizations'
				, exact: true
				, path: `reports/by-product/Organization`
				, queryParams: { reportType: ReportTypeEnum.Organization }
                , activeNavLink: 'reports/by-product/Organization'
                , secondaryNav: ['Reports', 'By Product', 'Organizations']
			}
            , {
				name: 'Sites'
				, exact: true
				, path: `reports/by-product/Site`
				, queryParams: { reportType: ReportTypeEnum.Site }
                , activeNavLink: 'reports/by-product/Site'
                , secondaryNav: ['Reports', 'By Product', 'Sites']
			}
		]		
	});

	return {
		name: 'Reports'
		, security: sec => sec.coreFeatures
		, children: navItems
		, href: `reports/inventory-count`
        , icon: faClipboardList
        , area: 'reports'
        , expanded: globalThis.location.href.includes("/reports/")
        , activeNavLink: 'reports/inventory-count'
        , secondaryNav: ['Reports', 'Inventory Count']
	};
};

function getBurnRateChildren() {
	let id: string = "";
	let url = globalThis.location.href;

	if (url.includes('reports/burn-rate/')) { id = url.substring(url.lastIndexOf('/') + 1); }
    if (id === "") { return; }

	return [
		{
			name: 'Burn Rate'
			, exact: true
			, path: `reports/burn-rate/${id}`
            , activeNavLink: 'reports/burn-rate'
            , secondaryNav: ['Reports', 'Report Burn Rate', 'Burn Rate']
		}
	]; 
}
